import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  getCategoryList() {
    return Api().get("/api/admin/get_gogo_category");
  },
  addMultipleSchedule(payload) {
    return Api().post("/api/admin/add-scheduling", payload);
  },
  addMultipleScheduleV2(payload) {
    return Api().post("/api/cinema/admin/addMultiSchedule", payload);
  },
  getSchedules(payload) {
    return Api().post(
      "/api/admin/gogo/getScheduleList?limit=" +
      payload.limit +
      "&currentPage=" +
      payload.currentPage,
      payload
    );
  },
  getSchedulesV2(payload) {
    return Api().post(
      "/api/cinema/admin/getScheduleList?limit=" +
      payload.limit +
      "&currentPage=" +
      payload.currentPage,
      payload
    );
  },
  GetCinemaSchedule(payload) {
    return Api().get(
      `/api/admin/gogo/cinemaschedule/${payload.cinema_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&ss_show_status=${payload.ss_show_status}`
    );
  },
  UpdateCinemaScheduleByPrice(payload) {
    return Api().put(
      `/api/admin/gogo/scheduleshowprice/${payload.gogo_ss_id}`,
      payload
    );
  },
  UpdateCinemaScheduleByShow(payload) {
    return Api().put(
      `/api/admin/gogo/scheduleshow/${payload.show_schedule_id}`,
      payload
    );
  },
  GetCategories(payload) {
    return Api().get(
      `/api/admin/get_gogo_category?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  UpdateCategory(payload) {
    return Api().put(
      `/api/admin/update_gogo_category/${payload.category_id}`,
      payload
    );
  },
  AddCategory(payload) {
    return Api().post(`/api/admin/add_gogo_category`, payload);
  },
  GetSingleCategory(payload) {
    return Api().get(`/api/admin/single_category/${payload.category_id}`);
  },
  GetSuperCategory(payload) {
    return Api().get(`/api/admin/super_category_list`);
  },
  AddCategoryLinkMovie(payload) {
    return Api().post(`/api/admin/category_link_movie_list`, payload);
  },
  GetCategoryLinkMovies(payload) {
    const query = createQueryString(payload);
    return Api().get(
      `/api/admin/category_link_movie_list${query}`
    );
  },
  GetSingleCategoryLinkMovie(payload) {
    return Api().get(
      `/api/admin/single_category_link_detail/${payload.category_id}`
    );
  },
  UpdateCategoryLinkMovie(payload, category_link_name) {
    return Api().put(
      `/api/admin/category_link_movie_list/${category_link_name}`,
      payload
    );
  },
  addMovieLicenceSchedule(payload) {
    return Api().post("/api/cinema/admin/addMovieLicenceSchedule", payload);
  },
  GetScheduleDetails(payload) {
    const { scheduleId } = payload;
    return Api().get(`api/cinema/admin/schedule-show-detail/${scheduleId}`);
  },
  UpdateSchedule(payload) {
    return Api().post(`api/cinema/admin/update-schedule-detail`, payload);
  },
  UpdateCMS(payload) {
    return Api().post(`/api/admin/cms/updatecms`, payload);
  },
  getAllMyCinemaCMS() {
    return Api().get(`/api/admin/cms/getAllCMS`);
  }
};



// WEBPACK FOOTER //
// ./src/services/MyCinemaService.js